import React from "react";

import RolePill from "../ui/RolePill";

import {
  ActeursPreview,
  BadgesPreview,
  ClubsPreview,
  CoachBadgeStatusControls,
  UserActions,
  UserIdentity,
} from "./UserCells";

export default function UsersTableDesktop({
  rows,
  loading,
  badgesByUser,

  onEdit,
  onDelete,
  onLinkClub,
  onMessage,

  onCoachBadge,
  exportingCoachBadgeUserId,

  onToggleCoachBadgePrinted,
  onToggleCoachBadgeReceived,
  coachBadgeUpdatingByUser,
}) {
  return (
    <div className="hidden lg:block">
      <div className="overflow-x-auto rounded-3xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <table className="w-full min-w-[1280px] table-fixed text-sm">
          <thead className="bg-slate-50 text-left dark:bg-slate-950/60">
            <tr className="text-slate-600 dark:text-slate-300">
              <th className="w-[19%] px-3 py-3 font-semibold">
                Utilisateur
              </th>

              <th className="w-[10%] px-3 py-3 font-semibold">
                Rôle
              </th>

              <th className="w-[18%] px-3 py-3 font-semibold">
                Clubs
              </th>

              <th className="w-[14%] px-3 py-3 font-semibold">
                Acteurs
              </th>

              <th className="w-[8%] px-3 py-3 font-semibold">
                Badges
              </th>

              <th className="w-[17%] px-3 py-3 font-semibold">
                Suivi carte coach
              </th>

              <th className="w-[14%] px-3 py-3 font-semibold">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
            {loading ? (
              <tr>
                <td
                  colSpan={7}
                  className="px-4 py-12 text-center text-slate-500"
                >
                  Chargement des utilisateurs…
                </td>
              </tr>
            ) : rows.length === 0 ? (
              <tr>
                <td
                  colSpan={7}
                  className="px-4 py-12 text-center text-slate-500"
                >
                  Aucun utilisateur ne correspond aux filtres.
                </td>
              </tr>
            ) : (
              rows.map((user) => {
                const userBadges =
                  badgesByUser[user.id] || [];

                const canGenerateCoachBadge =
                  userBadges.length > 0;

                const updatingField =
                  coachBadgeUpdatingByUser?.[
                    user.id
                  ] || null;

                return (
                  <tr
                    key={user.id}
                    className="align-top transition hover:bg-slate-50/80 dark:hover:bg-slate-800/40"
                  >
                    {/* Utilisateur */}
                    <td className="px-3 py-3.5">
                      <UserIdentity
                        user={user}
                      />
                    </td>

                    {/* Rôle */}
                    <td className="px-3 py-3.5">
                      <RolePill
                        roleId={
                          user.role_id
                        }
                      />
                    </td>

                    {/* Clubs */}
                    <td className="px-3 py-3.5">
                      <ClubsPreview
                        user={user}
                        onLinkClub={
                          onLinkClub
                        }
                        max={2}
                      />
                    </td>

                    {/* Acteurs */}
                    <td className="px-3 py-3.5">
                      <ActeursPreview
                        user={user}
                        max={2}
                      />
                    </td>

                    {/* Badges */}
                    <td className="px-3 py-3.5">
                      <BadgesPreview
                        badges={
                          userBadges
                        }
                      />
                    </td>

                    {/* Suivi carte coach */}
                    <td className="px-3 py-3.5">
                      <CoachBadgeStatusControls
                        user={user}
                        canManageCoachBadge={
                          canGenerateCoachBadge
                        }
                        onTogglePrinted={
                          onToggleCoachBadgePrinted
                        }
                        onToggleReceived={
                          onToggleCoachBadgeReceived
                        }
                        updatingField={
                          updatingField
                        }
                      />
                    </td>

                    {/* Actions */}
                    <td className="px-3 py-3.5">
                      <UserActions
                        user={user}
                        onEdit={onEdit}
                        onDelete={
                          onDelete
                        }
                        onMessage={
                          onMessage
                        }
                        onCoachBadge={
                          onCoachBadge
                        }
                        isCoachBadgeExporting={
                          Number(
                            exportingCoachBadgeUserId,
                          ) ===
                          Number(
                            user.id,
                          )
                        }
                        canGenerateCoachBadge={
                          canGenerateCoachBadge
                        }
                      />
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}